import { Button, ButtonSubmit, useListFilterState, useListGraphqlQuery, useTranslations } from "@bsm/component";
import { TNotification } from "@bsm/graphql";
import { useNotificationMarkAllAsReadMutation } from "hooks/useNotificationMarkAllAsReadMutation";
import moment from "moment";
import { useMemo, useState } from "react";
import { MAX_PAGE_SIZE, NOTIFICATION_LIST } from "./NotificationList";

export const NotificationListToobar = () => {


    const [ ALL, UNREAD, SHOW_MORE, MARK_ALL_AS_READ] = useTranslations(i18n);
    const { filter, setFilter } = useListFilterState(NOTIFICATION_LIST, true, {
        page: 0,
        pageSize: MAX_PAGE_SIZE,
        sort: [{ sort: "DESC", value: "createdAt" }],
    });
    const { data, invalidateQuery } = useListGraphqlQuery(NOTIFICATION_LIST)
    const [view, setView] = useState<"ALL" | "UNREAD">(
        filter.data && "dateRead" in filter.data ? "UNREAD" : "ALL"
    );
    const unreadNotifications = useMemo(() => {
        return (data?.["data"] as TNotification[])?.filter(
            (notification) => !notification.dateRead
        );
    }, [data]);
    const readAllMutation = useNotificationMarkAllAsReadMutation();


    const handleMarkAllAsReadClick = () => {
        readAllMutation.mutate(
            {
                data: unreadNotifications.map((notification) => ({
                    id: notification.id,
                    dateRead: moment().format(
                        moment.HTML5_FMT.DATETIME_LOCAL_MS
                    ),
                })),
            },
            {
                onSuccess: () => {
                    invalidateQuery();
                },
            }
        );
    }

    return (
        <div className="flex justify-between">
            <div className="flex gap-2 flex-nowrap">
                <Button
                    className={`btn ${view === "ALL" ? "btn-primary" : "btn-default"} !rounded-full`}
                    label={ALL}
                    onClick={() => {
                        setFilter((prevVal: any) => ({
                            ...prevVal,
                            data: undefined,
                        }));
                        setView("ALL");
                    }}
                />
                <Button
                    className={`btn ${view === "UNREAD" ? "btn-primary" : "btn-default"} !rounded-full`}
                    label={UNREAD}
                    onClick={() => {
                        setFilter((prevVal: any) => ({
                            ...prevVal,
                            data: {
                                dateRead_isNull: true,
                            },
                        }));
                        setView("UNREAD");
                    }}
                />
            </div>
            <div className="">
                <ButtonSubmit
                    onClick={handleMarkAllAsReadClick}
                    label={MARK_ALL_AS_READ}
                    className="btn-primary !rounded-full"
                    disabled={unreadNotifications && unreadNotifications?.length === 0}
                    isSubmit={readAllMutation.isLoading}
                />
            </div>
        </div>
    )
}

const i18n = [
    "BSMRH.Notification.List.Filter.All.Button.Label",
    "BSMRH.Notification.List.Filter.Unread.Button.Label",
    "std_show_more",
    "std_mark_all_as_read"
];
